/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_X13_Error_ExpiredInputs */

const en_portal_x13_error_expired = /** @type {(inputs: Portal_X13_Error_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This sign-in did not finish. Start again or use the email link.`)
};

/** @type {(inputs: Portal_X13_Error_ExpiredInputs) => LocalizedString} */
const ar_portal_x13_error_expired = en_portal_x13_error_expired;

/** @type {(inputs: Portal_X13_Error_ExpiredInputs) => LocalizedString} */
const he_portal_x13_error_expired = en_portal_x13_error_expired;

/** @type {(inputs: Portal_X13_Error_ExpiredInputs) => LocalizedString} */
const ur_portal_x13_error_expired = en_portal_x13_error_expired;

/** @type {(inputs: Portal_X13_Error_ExpiredInputs) => LocalizedString} */
const es_portal_x13_error_expired = en_portal_x13_error_expired;

/** @type {(inputs: Portal_X13_Error_ExpiredInputs) => LocalizedString} */
const fr_portal_x13_error_expired = en_portal_x13_error_expired;

/** @type {(inputs: Portal_X13_Error_ExpiredInputs) => LocalizedString} */
const de_portal_x13_error_expired = en_portal_x13_error_expired;

/** @type {(inputs: Portal_X13_Error_ExpiredInputs) => LocalizedString} */
const pt_portal_x13_error_expired = en_portal_x13_error_expired;

/** @type {(inputs: Portal_X13_Error_ExpiredInputs) => LocalizedString} */
const hi_portal_x13_error_expired = en_portal_x13_error_expired;

/** @type {(inputs: Portal_X13_Error_ExpiredInputs) => LocalizedString} */
const bn_portal_x13_error_expired = en_portal_x13_error_expired;

/**
* | output |
* | --- |
* | "This sign-in did not finish. Start again or use the email link." |
*
* @param {Portal_X13_Error_ExpiredInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const portal_x13_error_expired = /** @type {((inputs?: Portal_X13_Error_ExpiredInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_X13_Error_ExpiredInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_portal_x13_error_expired(inputs)
	if (locale === "he") return he_portal_x13_error_expired(inputs)
	if (locale === "ur") return ur_portal_x13_error_expired(inputs)
	if (locale === "es") return es_portal_x13_error_expired(inputs)
	if (locale === "fr") return fr_portal_x13_error_expired(inputs)
	if (locale === "de") return de_portal_x13_error_expired(inputs)
	if (locale === "pt") return pt_portal_x13_error_expired(inputs)
	if (locale === "hi") return hi_portal_x13_error_expired(inputs)
	if (locale === "bn") return bn_portal_x13_error_expired(inputs)
	return /** @type {LocalizedString} */ ("This sign-in did not finish. Start again or use the email link.")
});